module.exports = __webpack_public_path__ + "media/situations/icon-fire-182f7dd6.svg";